/**
 * lib/appVersion.js — etichetta di versione affidabile.
 *
 * Nel guscio NATIVO (Capacitor) restituisce la versione DELL'APK installato
 * (versionName + versionCode da @capacitor/app) — che bumpiamo a ogni build,
 * così l'utente vede esattamente cosa ha installato. Sul web/PWA restituisce
 * la versione del bundle (__APP_VERSION__) + il timestamp di build.
 */
import { isNativeApp } from './platform';

const WEB_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
const BUILD_ID = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : '';

export async function getVersionLabel() {
  if (isNativeApp()) {
    try {
      const { App } = await import('@capacitor/app');
      const info = await App.getInfo();
      // es. "APK 1.5-ver (build 6)"
      return `APK ${info.version} (build ${info.build})`;
    } catch { /* fallback sotto */ }
  }
  return `v${WEB_VERSION}${BUILD_ID ? ' · ' + BUILD_ID : ''}`;
}

// Versione COMPATTA per la barra in alto (memoizzata: il Frame è su ogni schermata).
let _short = null;
export async function getVersionShort() {
  if (_short) return _short;
  if (isNativeApp()) {
    try {
      const { App } = await import('@capacitor/app');
      const info = await App.getInfo();
      _short = `${info.version}·b${info.build}`; // es. "1.5-ver·b6"
      return _short;
    } catch { /* fallback sotto */ }
  }
  _short = `v${WEB_VERSION}`;
  return _short;
}
